import { BlobServiceClient } from '@azure/storage-blob';
import { getStorage, setStorage, STORAGE_KEY } from 'helpers/storage';

export const getBlobContainer = (connectionString: string) => {
  const blobUrl = new URL(connectionString);
  const pathname = blobUrl.pathname?.split('/');

  const containerName = pathname[2];
  const blobServiceClient = new BlobServiceClient(
    connectionString?.replace(blobUrl.pathname, '/' + pathname[1])
  );
  return blobServiceClient.getContainerClient(containerName);
};

export const getStorageReadBlobToken = () => {
  return getStorage(STORAGE_KEY.READ_BLOB_TOKEN);
};

export const setStorageReadBlobToken = (token: string) => {
  setStorage(STORAGE_KEY.READ_BLOB_TOKEN, token);
};

export const downloadFileBlob = (file: Blob, fileName: string) => {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = URL.createObjectURL(file);
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    URL.revokeObjectURL(link.href);
    link.parentNode?.removeChild(link);
  }, 0);
};
